"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWeeklyRepeat = exports.setMonthlyRepeat = exports.setDailyRepeat = exports.generateRepeatString = void 0;
var constants_1 = require("../constants");
var datetime_1 = require("./datetime");
// Delimits the frequency part from the rest.
var REPEAT_DELIM = "*";
// Delimits the fragments of repeatData string.
var FRAGMENT_DELIM = ":";
// Delimits parts in one fragment.
var LIST_DELIM = ",";
// Position of the REPEAT_DELIM determines the type of the repeat
var REPEAT_TYPE_BY_REPEAT_INDEX = ["none", "yearly", "monthly", "weekly", "daily"];
// Name of the each frangment by position.
var FRAGMENT_BY_INDEX = ["year", "month", "week", "day", "hour", "minute", "second"];
// Fills fragments to respective places.
function fillFragments(fragments, fragObj) {
    for (var name_1 in fragObj) {
        // eslint-disable-next-line no-prototype-builtins
        if (!fragObj.hasOwnProperty(name_1)) {
            continue;
        }
        var index = FRAGMENT_BY_INDEX.indexOf(name_1);
        fragments[index] = fragObj[name_1];
    }
}
function getRepeatBase(repeatType, repeatFrequency) {
    if (repeatType !== constants_1.REPEAT_TYPES.CUSTOM) {
        return repeatType;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (repeatFrequency.hasOwnProperty("day")) {
        return constants_1.REPEAT_TYPES.DAILY;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (repeatFrequency.hasOwnProperty("week")) {
        return constants_1.REPEAT_TYPES.WEEKLY;
    }
    return constants_1.REPEAT_TYPES.MONTHLY;
}
// Generates repeatData string
function generateRepeatString(repeatData) {
    var repeatExecuteOn = repeatData.repeatExecuteOn, // repeatSubType
    repeatFrequency = repeatData.repeatFrequency, // repeatStruct
    repeatPeriod = repeatData.repeatPeriod, repeatType = repeatData.repeatType, // repeatBase
    time = repeatData.time;
    var fragments = [0, 0, 0, 0, 0, 0, 0];
    var repeatBase = getRepeatBase(repeatType, repeatFrequency);
    var repeatDelimIndex = REPEAT_TYPE_BY_REPEAT_INDEX.indexOf(repeatBase);
    // Repeats monthly
    if (repeatBase === constants_1.REPEAT_TYPES.MONTHLY) {
        var str = repeatFrequency.month;
        // Repeats on a day of week in n-th week of month (e.g. 3rd Monday)
        if (repeatExecuteOn === constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK) {
            var day = str.dayOfWeek.day;
            var week = str.dayOfWeek.week;
            fillFragments(fragments, { day: day, week: week });
        }
        // Repeats on a day of month 1-31
        else if (repeatExecuteOn === constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH) {
            var day = str.dayOfMonth;
            fillFragments(fragments, { day: day });
        }
    }
    // Repeats weekly
    else if (repeatBase === constants_1.REPEAT_TYPES.WEEKLY) {
        var days = repeatFrequency.week.days;
        fillFragments(fragments, { day: days.join(LIST_DELIM) });
    }
    // Repeats daily
    else if (repeatBase === constants_1.REPEAT_TYPES.DAILY) {
        // do nothing
    }
    // Fill the repeat period
    fragments[repeatDelimIndex - 1] = repeatPeriod;
    // Fill the time
    fillFragments(fragments, time);
    // Split array of fragments into frequency part and when part (so I can join them with '*' afterwards)
    var reptParts = [
        fragments.slice(0, repeatDelimIndex),
        fragments.slice(repeatDelimIndex, fragments.length),
    ];
    // Join into one repeatData string
    return reptParts.map(function (p) { return p.join(FRAGMENT_DELIM); }).join(REPEAT_DELIM);
}
exports.generateRepeatString = generateRepeatString;
function setDailyRepeat(repeatData) {
    repeatData.repeatFrequency = {
        day: true,
    };
}
exports.setDailyRepeat = setDailyRepeat;
function setMonthlyRepeat(repeatData, repeatExecuteOn, startDate) {
    var _a;
    var repeatExecuteOnData;
    if (repeatExecuteOn === constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH) {
        repeatExecuteOnData = datetime_1.getDate(startDate);
    }
    else if (repeatExecuteOn === constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK) {
        repeatExecuteOnData = {
            day: datetime_1.getDay(startDate),
            week: datetime_1.getWeek(startDate),
        };
    }
    repeatData.repeatExecuteOn = repeatExecuteOn;
    repeatData.repeatFrequency = {
        month: (_a = {
                type: repeatExecuteOn
            },
            _a[repeatExecuteOn] = repeatExecuteOnData,
            _a),
    };
}
exports.setMonthlyRepeat = setMonthlyRepeat;
function setWeeklyRepeat(repeatData, startDate) {
    repeatData.repeatFrequency = {
        week: {
            days: [datetime_1.getDay(startDate)],
        },
    };
}
exports.setWeeklyRepeat = setWeeklyRepeat;
//# sourceMappingURL=repeat.js.map